<!--带有分页逻辑的table-->
<template>
  <div class="vm-page-table">
    <div v-if="$slots.toolbar" class="tools-bar">
      <slot name="toolbar" />
    </div>
    <div v-if="$slots.adSearch" ref="adSearch" class="ad-search">
      <div id="search" class="ad-search_content">
        <slot name="adSearch" />
        <div class="ad-search-btn">
          <el-button :loading="status === 'loading'" type="primary" size="mini" style="height: 26px;padding: 0 10px"
            @click="handleSearchClick">
            查询
          </el-button>
          <el-button v-if="!hideClear" plain type="primary" size="mini" style="height: 26px;padding: 0 10px"
            @click="handleClearClick">
            重置
          </el-button>
        </div>
      </div>
    </div>
    <div class="wrapper">
      <el-table ref="elTable" v-loading="status === 'loading' && tableData.length > 0" v-bind="$attrs" stripe border
        :row-key="rowKey" :data="tableData" v-on="$listeners" :expand-row-keys="expandRowKeys">
        <template slot="empty">
          <i v-if="status === 'loading'" class="el-icon-loading" style="font-size: 18px" />
          <el-button v-else-if="status === 'error'" @click="handleSearchClick">加载失败，点击重新获取</el-button>
          <div v-else-if="status === 'empty'">暂无数据</div>
        </template>
        <el-table-column v-if="showRadio" align="center" width="50">
          <template slot-scope="scope">
            <el-checkbox :value="scope.$index === currentRowIndex" @change="onCheckedChange($event, scope.$index)" />
          </template>
        </el-table-column>
        <slot />
      </el-table>
      <div v-if="!noPage" style="margin-top: 16px;overflow: hidden">
        <el-pagination background class="page" :current-page="currentPage"
          layout="total,sizes, prev, pager, next, jumper" :total="total"
          :page-sizes="[10, 50, 100, 200, 300, 500, 1000]" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" />
      </div>
    </div>
  </div>
</template>

<script>
/*查询条件filter必须使用:filter.sync="filter"传递*/
export default {
  components: {},
  props: {
    module: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    method: {
      type: String,
      default: "get",
    },
    method1: {
      type: String,
      default: "get",
    },
    filter: {
      type: Object,
    },
    //是否显示清空按钮
    hideClear: {
      type: Boolean,
      default: false,
    },
    //是否有分页
    noPage: {
      type: Boolean,
      default: false,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    showRadio: {
      type: Boolean,
      default: false,
    },
    rowKey: {
      type: String,
      default: "pkid",
    }
  },
  data() {
    return {
      status: "loading",//loading error empty
      currentPage: 1,
      total: 0,
      tableData: [],
      //保存一份filter的原始拷贝，用于重置条件
      filterCopy: JSON.stringify(this.filter),
      currentRowIndex: -1,
      expandRowKeys: []
    };
  },
  mounted() {
    //为所有input框添加enter键搜索事件
    let searchBox = document.getElementById("search");
    if (searchBox) {
      let controls = searchBox.getElementsByTagName("input");
      for (let item of controls) {
        item.onkeydown = event => {
          if (event.key === "Enter") {
            this.getList(1);
          }
        };
      }
    }
  },
  methods: {
    // 全部展开
    expandAll() {
      this.tableData.forEach(item => {
        this.expandRowKeys.push(item.itemID);
      })
    },

    // 全部折叠
    foldAll() {
      this.expandRowKeys = [];
    },

    getList(pageNum) {
      if (this.noPage) {
        this.getListNoPage();
      } else {
        this.getListWithPage(pageNum);
      }
    },
    //等于-1表示获取当前页
    getListWithPage(pageNum) {
      this.status = "loading";
      if (pageNum > 0) {
        this.currentPage = pageNum;
      }
      let params = Object.assign({ pageSize: this.pageSize, pageNum: this.currentPage }, this.filter);
      let config = {
        url: this.url,
        method: this.method,
      };
      if (this.method === "post") {
        config.data = params;
      } else {
        config.params = params;
      }
      this.$http
        .request(this.module, config)
        .then(data => {
          this.tableData = data.records;
          this.total = data.total;
          console.log(this.tableData);
          if (this.total === 0) {
            this.status = "empty";
          } else {
            this.status = "finish";
          }
        })
        .catch(() => {
          this.status = "error";
        });
    },
    getListNoPage() {
      this.status = "loading";
      let config = {
        url: this.url,
        method: this.method,
      };
      if (this.method === "post") {
        config.data = this.filter;
      } else {
        config.params = this.filter;
      }
      this.$http
        .request(this.module, config)
        .then(data => {
          this.tableData = data;
          if (!data || data.length === 0) {
            this.status = "empty";
          } else {
            this.status = "finish";
          }
        })
        .catch(() => {
          this.status = "error";
        });
    },
    // 切换分页显示的条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getListWithPage(1);
    },

    handleCurrentChange(pageNum) {
      this.getList(pageNum);
    },
    handleSearchClick() {
      this.getList(1);
    },
    handleClearClick() {
      if (this.rowKey === "itemID") {
        this.$emit("updateTree");
      } else {
        this.$emit("update:filter", JSON.parse(this.filterCopy));
      }
      this.$nextTick(() => {
        this.getList(1);
      });
    },
    onCheckedChange(val, index) {
      this.currentRowIndex = val ? index : -1;
      this.$emit("radio-change", this.tableData[this.currentRowIndex], val);
    },
    clearSelection() {
      this.$refs.elTable.clearSelection();
    },
  },
};
</script>

<style lang="scss">
.vm-page-table {

  .tools-bar {
    margin-bottom: 10px;
  }

  .ad-search {
    overflow: auto;
    width: auto;
    border: 1px solid #EBEEF5;
    margin-bottom: 10px;
    background-color: #f4f7fa;

    .ad-search_content {
      position: relative;
      display: inline-block;
      padding: 8px 133px 8px 10px;

      .ad-search-btn {
        position: absolute;
        right: 10px;
        bottom: 11px;
      }
    }
  }

  .page {
    float: right;
  }

  .el-loading-spinner {
    position: fixed;
    width: 100px;
    top: 50%;
    left: 50%;
  }
}
</style>
